import { ApolloLink } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';

import { env } from '@neo.tax/shared/utils';

export const httpLink = createUploadLink({
  uri: `${env.REACT_APP_BACKEND_BASE_URL}/graphql`,
  headers: {
    'apollo-require-preflight': 'true',
  },
}) as unknown as ApolloLink;
